module.exports = __webpack_public_path__ + "static/media/logo_adlatus.a01f5269.png";